export const useCurrency = (val: number | undefined = undefined): string => {
  if (val !== undefined) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return formatter.format(val);
  }
  return '';
};
